import React from 'react';
import { number, oneOfType, shape, string } from 'prop-types';
import { StorePin } from '../StorePin/StorePin';
import { storeShape } from '../storeShape';

const MAP_KEY = 'AoKTFnu3hdkRgVWl45fcxdz0WSDP6hroMDcPKXE4ZkQql3hPt3PtkCDwtNRCYgYA';

const StoreMapPreview = ({ mapOptions, store }) => {
  const mapOptionsMerged = { ...StoreMapPreview.defaultProps.mapOptions, ...mapOptions };

  const { height: mapHeight, width: mapWidth, zoom } = mapOptionsMerged;
  const { address, coordinates } = store || {};
  const { street, city, state, postalCode } = address || {};
  const { lat, lng } = coordinates || {};

  if (!address || !coordinates) return null;

  const bingMapURL = `https://www.bing.com/mapspreview?where1=${street}, ${city}, ${state} ${postalCode}&sty=c`;
  const bingMapSrcQueries = `${lat},${lng}/${zoom}?mapSize=${mapWidth},${mapHeight}&key=${MAP_KEY}`;
  const bingMapSrc = `https://dev.virtualearth.net/REST/v1/Imagery/Map/Road/${bingMapSrcQueries}`;

  return (
    <div data-testid="store-map-preview" className="sui-relative" data-component="StoreMapPreview">
      <a rel="nofollow noreferrer" target="_blank" href={bingMapURL}>
        <div className="sui-h-fit sui-relative sui-w-fit">
          {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
          <div className="sui-left-[calc(50%-8px)] sui-top-[calc(50%-15px)] sui-absolute sui-z-10">
            <StorePin mini />
          </div>
          <img
            src={bingMapSrc}
            alt="map preview"
            height={mapHeight}
            width={mapWidth}
            loading="lazy"
          />
        </div>
      </a>
    </div>
  );
};

StoreMapPreview.propTypes = {
  mapOptions: shape({
    height: oneOfType([string, number]),
    width: oneOfType([string, number]),
    zoom: oneOfType([string, number])
  }),
  store: storeShape
};

StoreMapPreview.defaultProps = {
  mapOptions: {
    height: '100',
    width: '100',
    zoom: '13'
  },
  store: {}
};

StoreMapPreview.displayName = 'StoreMapPreview';

export { StoreMapPreview };
